export default "__VITE_ASSET__CUT4V0Fk__"